import React, { useState, useEffect } from 'react';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';
import { host_url } from '../../App';
import '../ListenSubpage.css';
import './SpeiseplanVerwaltung.css';

const WOCHENTAGE = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

const MAHLZEITEN = [
  { key: 'Fruehstueck', label: 'Frühstück',  icon: 'bakery_dining',  defaultUhrzeit: '07:30' },
  { key: 'Mittagessen', label: 'Mittagessen', icon: 'lunch_dining',  defaultUhrzeit: '12:00' },
  { key: 'Abendessen',  label: 'Abendessen',  icon: 'dinner_dining', defaultUhrzeit: '18:00' },
];

function getHeutigerWochentag() {
  const jsTag = new Date().getDay();
  return WOCHENTAGE[jsTag === 0 ? 6 : jsTag - 1];
}

function SpeiseplanVerwaltung() {
  const [daten, setDaten] = useState([]);
  const [tag, setTag] = useState(getHeutigerWochentag());
  const [successMsg, setSuccessMsg] = useState('');

  // Lokale Formular-States pro Mahlzeit
  const [formState, setFormState] = useState({});

  const fetchDaten = async () => {
    try {
      const res = await fetch(`${host_url}/speiseplan`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setDaten(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Fehler beim Laden des Speiseplans:', err);
      setDaten([]);
    }
  };

  useEffect(() => {
    fetchDaten();
  }, []);

  // Wenn Tag oder Daten wechseln: Formular-State aktualisieren
  useEffect(() => {
    const newFormState = {};
    MAHLZEITEN.forEach(({ key, defaultUhrzeit }) => {
      const eintrag = daten.find((e) => e.Wochentag === tag && e.Mahlzeit === key);
      newFormState[key] = {
        id: eintrag?.ID || null,
        // Vorhandene Einträge behalten ihre gespeicherte Uhrzeit; neue Einträge
        // bekommen die Standard-Uhrzeit der jeweiligen Mahlzeit vorausgewählt.
        uhrzeit: eintrag?.Uhrzeit || defaultUhrzeit,
        gericht: eintrag?.Gericht || '',
      };
    });
    setFormState(newFormState);
  }, [tag, daten]);

  const handleChange = (mahlzeit, field, value) => {
    setFormState((prev) => ({
      ...prev,
      [mahlzeit]: { ...prev[mahlzeit], [field]: value },
    }));
  };

  const handleSave = async (mahlzeitKey) => {
    const entry = formState[mahlzeitKey];
    if (!entry.uhrzeit || !entry.gericht) return;

    const body = {
      Wochentag: tag,
      Mahlzeit: mahlzeitKey,
      Uhrzeit: entry.uhrzeit,
      Gericht: entry.gericht,
    };

    try {
      let res;
      if (entry.id) {
        // Update
        res = await fetch(`${host_url}/speiseplan/${entry.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
      } else {
        // Create
        res = await fetch(`${host_url}/speiseplan`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
      }
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSuccessMsg(entry.id ? 'Eintrag aktualisiert!' : 'Eintrag erstellt!');
      fetchDaten();
    } catch (err) {
      console.error('Fehler beim Speichern:', err);
      setSuccessMsg('');
      alert('Fehler beim Speichern. Bitte prüfe, ob die Datenbank-Tabelle existiert.');
    }
  };

  const handleDelete = async (mahlzeitKey) => {
    const entry = formState[mahlzeitKey];
    if (!entry.id) return;

    try {
      const res = await fetch(`${host_url}/speiseplan/${entry.id}`, {
        method: 'DELETE',
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSuccessMsg('Eintrag gelöscht!');
      fetchDaten();
    } catch (err) {
      console.error('Fehler beim Löschen:', err);
      alert('Fehler beim Löschen.');
    }
  };

  return (
    <KernteamLayout>
      <div className="container">
        <BackArrow to="/listen" />
        <h1 className="section-title blue">Speiseplan</h1>

        {/* Wochentag-Tabs */}
        <div className="speiseplan-admin-tabs">
          {WOCHENTAGE.map((wochentag) => (
            <button
              key={wochentag}
              className={`speiseplan-admin-tab ${tag === wochentag ? 'active' : ''}`}
              onClick={() => setTag(wochentag)}
            >
              {wochentag.substring(0, 2)}
            </button>
          ))}
        </div>

        {/* Mahlzeit-Karten */}
        <div className="meal-admin-cards" key={tag}>
          {MAHLZEITEN.map(({ key, label, icon }) => {
            const entry = formState[key] || { id: null, uhrzeit: '', gericht: '' };
            return (
              <div className="meal-admin-card" key={key}>
                <div className="meal-admin-card-header">
                  <span className="material-symbols-outlined">{icon}</span>
                  <h3>{label}</h3>
                </div>

                <label>Uhrzeit</label>
                <input
                  type="text"
                  placeholder="z.B. 07:30 – 09:00 Uhr"
                  value={entry.uhrzeit}
                  onChange={(e) => handleChange(key, 'uhrzeit', e.target.value)}
                />

                <label>Gericht</label>
                <input
                  type="text"
                  placeholder="z.B. Brötchen, Marmelade, Müsli"
                  value={entry.gericht}
                  onChange={(e) => handleChange(key, 'gericht', e.target.value)}
                />

                <div className="meal-admin-card-actions">
                  <button
                    className="btn-save"
                    onClick={() => handleSave(key)}
                    disabled={!entry.uhrzeit || !entry.gericht}
                  >
                    <span className="material-symbols-outlined">save</span>
                    {entry.id ? 'Aktualisieren' : 'Speichern'}
                  </button>
                  {entry.id && (
                    <button className="btn-delete" onClick={() => handleDelete(key)}>
                      <span className="material-symbols-outlined">delete</span>
                      Löschen
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {successMsg && (
          <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
        )}
      </div>
    </KernteamLayout>
  );
}

export default SpeiseplanVerwaltung;
